import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { HttpParams } from '@angular/common/http';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, Editor, Toolbar, NgxEditorComponent } from 'ngx-editor';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { MemoryStorageService } from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-emailmanager',
  templateUrl: './emailmanager.component.html',
  styleUrls: ['./emailmanager.component.css'],
})
export class EmailmanagerComponent implements OnInit, AfterViewInit {
  lstDocumentType: any = [];
  ddlDocumentType: number = -1;
  emailTemplateName: string = '';
  emailTemplateStatus: string = '';

  emailSubject: string = '';
  emailBody: string = '';

  ddlFieldsForSubject = 0;
  ddlFieldsForBody = 0;
  lstSubjectFields: any = [];

  lstMacroFields: any = [
    {
      value: 'Vendor',
      text: 'Vendor details',
      item: [
        { value: 9268, text: 'Company Code' },
        { value: 9269, text: 'Delivery Date' },
        { value: 9271, text: 'Currency' },
        { value: 9231, text: 'VendorNumber' },
        { value: 9232, text: 'VendorName' },
      ],
    },
    {
      value: 'Invoice',
      text: 'Invoice details',
      item: [
        { value: 9228, text: 'Cost Center' },
        { value: 9233, text: 'BaselineDate' },
        { value: 9234, text: 'Posting Date' },
        { value: 9235, text: 'InvoiceAmount' },
        { value: 9236, text: 'Taxcode' },
        { value: 9237, text: 'CalcTaxIndicator' },
      ],
    },
    {
      value: 'Payment',
      text: 'Payment details',
      item: [
        { value: 9238, text: 'PmtTerms' },
        { value: 9239, text: 'PmtMethod' },
        { value: 9240, text: 'Text' },
        { value: 9241, text: 'AssignmentText' },
        { value: 9242, text: 'HeaderText' },
        { value: 9243, text: 'G/L A/c' },
        { value: 9244, text: 'Dr/Cr' },
        { value: 9245, text: 'Taxcode' },
      ],
    },
  ];

  lstBodyFields: any = [
    { value: 9238, text: 'PmtTerms' },
    { value: 9239, text: 'PmtMethod' },
    { value: 9240, text: 'Text' },
    { value: 9241, text: 'AssignmentText' },
    { value: 9242, text: 'HeaderText' },
    { value: 9243, text: 'G/L A/c' },
    { value: 9244, text: 'Dr/Cr' },
    { value: 9245, text: 'Taxcode' },
  ];

  lstAdditionalFeature: any = [
    { value: '1', text: 'Include Comments' },
    { value: '2', text: ' Include Attachment' },
    { value: '3', text: ' Include Reason' },
    { value: '4', text: ' Include CheckList' },
    { value: '5', text: ' Include Subject Line' },
  ];

  lstTemplateStatus: any = [
    { value: '', text: '--Select--' },
    { value: 'ACTIVE', text: 'Active' },
    { value: 'INACTIVE', text: 'InActive' },
  ];

  bodyEditor: Editor;
  bodyHtml: '';

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  bodyform = new FormGroup({
    editorContent: new FormControl(
      { value: '', disabled: false },
      Validators.required()
    ),
  });

  onMouseFocused: string = '';
  @ViewChild("elSubject") elSubject: ElementRef

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    private commonService: CommonService,
    private route: Router,
    private modalService: NgbModal,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {
    //wowService.init();
  }

  get bodyDoc(): AbstractControl {
    return this.bodyform.get('bodyeditorContent');
  }

  ngOnInit(): void {
    this.bodyEditor = new Editor();
    this.lstSubjectFields = this.lstBodyFields;
    this.getDocumentTypes();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      let elem: any = document.getElementsByClassName('NgxEditor');
      if (elem != undefined) {
        elem[0].setAttribute('style', 'min-height:300px');
        elem[0].addEventListener('focus', function () {
          this.onFocusBodyConent();
        });
      }

      var acc = document.getElementsByClassName('accordion');
      var i;
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function () {
          this.classList.toggle('active');
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      }
    }, 2000);
  }
  ngOnDestroy(): void {
    this.bodyEditor.destroy();
  }

  getDocumentTypes() {
    this.lstDocumentType = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService
      .getData('document-types', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.lstDocumentType.push({ value: -1, text: '--Select--' });
              res.data.forEach((element) => {
                this.lstDocumentType.push({
                  value: element.document_type_id,
                  text: element.document_type_name,
                });
              });
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.route.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          this.commonService.showMessageBox(error.toString());
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }
  onDocmentTypeSelectionChanged(value: number) { }
  saveEmailTemplate() { }
  clearTemplateForm() {
    this.bodyEditor = new Editor();
    this.ddlDocumentType = -1;
    this.emailTemplateName = '';
  }

  onChangeFieldBody(value: string) {

    if (this.onMouseFocused == 'subject') {
      this.emailSubject += value;
      this.onMouseFocused = "";
    } else {
      this.bodyEditor.commands
        .insertText(value)
        .focus()
        .scrollIntoView()
        .exec();
    }

  }

  focusFunction(flag: string) {
    this.onMouseFocused = flag;
  }
  focusOutFunction(flag: string) {
    //this.onMouseFocused="";
  }
}
